import { PayloadAction } from "@reduxjs/toolkit";

export function setSearchStringReducer(state, action: PayloadAction<string>) {
  state.searchString = action.payload;
}
